export default function Ornament({ className = "" }) {
  return (
    <div
      className={`flex items-center justify-center gap-4 my-10 ${className}`}
      aria-hidden="true"
    >
      <span className="h-px w-16 bg-ink" />
      <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
        <path
          d="M11 1 L13 9 L21 11 L13 13 L11 21 L9 13 L1 11 L9 9 Z"
          stroke="#121212"
          strokeWidth="1"
          fill="#121212"
        />
      </svg>
      <span className="h-px w-16 bg-ink" />
    </div>
  );
}
